<template>
    <div class="preview-subject-lecture">
        <standard-header left-div="back" title="시리즈" />

        <!-- 과목 선택 메뉴 -->
        <div class="subject-select-menu" hidden>
            <ul class="subject-select-list">
                <li class="" @click="menuClickEvent('00')" v-bind:class="{'selected-menu' : subjectMenu === '00' }" v-bind:style="{width: subjectWidth+'%'}">전체</li>
                <li v-for="(subject, index) in subjectList" :key="index" @click="menuClickEvent(subject.subject)" v-bind:class="{'selected-menu' : subjectMenu === subject.subject }" v-bind:style="{width: subjectWidth+'%'}">{{ subject.subject_name }}</li>
            </ul>
        </div>

        <!-- 학교 학년 선택 메뉴 -->
        <div class="school-select-section" @click="isDisplayPopup = true" hidden>
            <div class="text">{{ schoolDivGradeName }}</div>
            <div class="button"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/school-select.png" /></div>
        </div>

        <!-- 학교 학년 ion-select (화면에는 숨김)-->
        <!-- <ion-item v-show="false">
            <ion-label>학년 선택</ion-label>
            <ion-select mode="ios" interface="alert" cancel-text="취소" ok-text="선택" @ionChange="changeSchoolGrade($event.target.value, '00')">
                <ion-select-option value="1001">초등 1학년</ion-select-option>
                <ion-select-option value="1002">초등 2학년</ion-select-option>
                <ion-select-option value="1003">초등 3학년</ion-select-option>
                <ion-select-option value="1004">초등 4학년</ion-select-option>
                <ion-select-option value="1005">초등 5학년</ion-select-option>
                <ion-select-option value="1006">초등 6학년</ion-select-option>
                <ion-select-option value="2001">중등 1학년</ion-select-option>
                <ion-select-option value="2002">중등 2학년</ion-select-option>
                <ion-select-option value="2003">중등 3학년</ion-select-option>
            </ion-select>
        </ion-item> -->

        <!-- 교과 동화: No Data -->
        <div class="course-no-list-section" v-if="isShowNoData() === 0">검색된 동화가 없습니다</div>

        <!-- 교과 동화: List -->
        <ul class="course-2n-list-vertical">
            <li v-for="(lecture, index) in lectureList" v-if="isShowLecture(lecture.subject)" @click="lectureInfoEvent(lecture.lecture_no)">
                <div class="course-image">
                    <img v-if="lecture.lecture_image_url !== null && lecture.lecture_image_url !== ''" v-bind:src="lecture.lecture_image_url" />
                    <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/content/course/201908/da2302a0d96147c5b40d43e5e94782cf.png" />
                    <div class="play-image">
                        <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/lecture-white-player.png" />
                    </div>
                </div>
                <div class="course-title word_comma_2" @click="lectureInfoEvent(lecture.lecture_no)">{{ lecture.lecture_title }}({{ lecture.total_class_count }})</div>
                <div class="teacher-info" hidden>{{ lecture.teacher_name }}<span> · {{ lecture.teacher_div_name }}</span></div>
            </li>
        </ul>

        <footer-toolbar />

        <school-choice v-if="isDisplayPopup" @showDisplay="displayPopup" @updateSchool="updateSchool" />
    </div>
</template>

<script>
    import * as biz from '../../utils/biz';
    import * as ajax from '../../utils/ajax'
    import StandardHeader from "../../components/header/StandardHeader";
    import FooterToolbar from "../../components/footer/FooterToolbar";
    import SchoolChoice from "../../components/popup/SchoolChoice";

    export default {
        name: 'SubjectLecture',
        components: {StandardHeader, FooterToolbar, SchoolChoice},
        props: {
            subject: String
        },
        data() {
            return {
                isDisplayPopup: false,
                schoolDivGradeName: "",
                schoolDiv: "",
                schoolGrade: "",
                tempSchoolDiv: "",
                tempSchoolGrade: "",
                subjectMenu: "",
                subjectWidth: "100",
                subjectList: [],
                lectureList: []
            }
        },
        beforeRouteLeave (to, from, next) {
            const url = to.path;
            if (url.indexOf("/preview/lecture/info/") !== -1) {
                this.$cookie.set("tempSchoolDiv", this.schoolDiv);
                this.$cookie.set("tempSchoolGrade", this.schoolGrade);
            } else {
                this.$cookie.set("tempSchoolDiv", "");
                this.$cookie.set("tempSchoolGrade", "");
            }
            next(vm => {});
        },
        created() {
            this.$store.state.toolbarActivePosition = "preview";
            this.$store.state.basicPlayerVisiblity = true;
            this.tempSchoolDiv = this.$cookie.get("tempSchoolDiv");
            this.tempSchoolGrade = this.$cookie.get("tempSchoolGrade");
            this.schoolDiv = this.$cookie.get("schoolDiv");
            this.schoolGrade = this.$cookie.get("schoolGrade");
            this.subjectMenu = this.subject;
        },
        mounted() {
            if (this.tempSchoolDiv !== "" && this.tempSchoolDiv !== null && this.tempSchoolGrade !== "" && this.tempSchoolGrade !== null) {
                this.changeSchoolGrade(this.tempSchoolDiv + this.tempSchoolGrade, this.subjectMenu);
            } else {
                this.changeSchoolGrade(this.schoolDiv + this.schoolGrade, this.subjectMenu);
            }
        },
        methods: {
            playLecture(course_no) {
                biz.playAudioPlayer(course_no);
            },
            menuClickEvent(subject) {
                this.subjectMenu = subject;
            },
            isShowNoData() {
                const subjectMenu = this.subjectMenu;
                let lectureList = this.lectureList;

                if (subjectMenu === "00") {
                    return lectureList.length;
                } else {
                    let cnt = 0;
                    for (let i in lectureList) {
                        if (lectureList[i].subject === subjectMenu) {
                            cnt += 1;
                        }
                    }
                    return cnt;
                }
            },
            isShowLecture(subject) {
                if (this.subjectMenu === "00") {
                    return true;
                } else {
                    return this.subjectMenu === subject;
                }
            },
            IonSelectEvent() {
                const select = document.querySelector('ion-select[interface="alert"]');
                select.click();
            },
            changeSchoolGrade(schoolDivGrade, subject) {
                switch (schoolDivGrade) {
                    case "1001":
                        this.schoolDiv = "10";
                        this.schoolGrade = "01";
                        this.schoolDivGradeName = "초등 1학년";
                        break;
                    case "1002":
                        this.schoolDiv = "10";
                        this.schoolGrade = "02";
                        this.schoolDivGradeName = "초등 2학년";
                        break;
                    case "1003":
                        this.schoolDiv = "10";
                        this.schoolGrade = "03";
                        this.schoolDivGradeName = "초등 3학년";
                        break;
                    case "1004":
                        this.schoolDiv = "10";
                        this.schoolGrade = "04";
                        this.schoolDivGradeName = "초등 4학년";
                        break;
                    case "1005":
                        this.schoolDiv = "10";
                        this.schoolGrade = "05";
                        this.schoolDivGradeName = "초등 5학년";
                        break;
                    case "1006":
                        this.schoolDiv = "10";
                        this.schoolGrade = "06";
                        this.schoolDivGradeName = "초등 6학년";
                        break;
                    case "2001":
                        this.schoolDiv = "20";
                        this.schoolGrade = "01";
                        this.schoolDivGradeName = "중등 1학년";
                        break;
                    case "2002":
                        this.schoolDiv = "20";
                        this.schoolGrade = "02";
                        this.schoolDivGradeName = "중등 2학년";
                        break;
                    case "2003":
                        this.schoolDiv = "20";
                        this.schoolGrade = "03";
                        this.schoolDivGradeName = "중등 3학년";
                        break;
                }

                this.getSubjectList();
                this.getLectureList();
                this.subjectMenu = subject;
            },
            getSubjectList() {
                const params = {
                    schoolDiv: this.schoolDiv,
                    schoolGrade: this.schoolGrade,
                    lectureDiv: "10"
                };
                ajax.Post(this, "/api/contents/lecture/subject", params, function(ref, data) {
                    ref.subjectList = data;
                    if (data.length !== 0) {
                        ref.subjectWidth = 100 / data.length;
                    } else {
                        ref.subjectWidth = 100
                    }
                });
            },
            getLectureList() {
                const params = {
                    school_div: this.schoolDiv,
                    school_grade: this.schoolGrade,
                    lecture_div: "10",
                    public_yn: "Y",
                    open_date: "today"
                };
                ajax.Post(this, "/api/contents/lecture/search", params, function(ref, data) {
                    ref.lectureList = data;
                });
            },
            lectureInfoEvent(lecture_no) {
                const url = "/preview/lecture/info/" + lecture_no;
                this.$router.push(url);
            },
            displayPopup(isDisplayPopup) {
                this.isDisplayPopup = isDisplayPopup;
            },
            updateSchool(schoolDiv, schoolGrade) {
                let schoolName = "";
                switch(schoolDiv) {
                    case "10":
                        schoolName = "초등학교";
                        break;
                    case "20":
                        schoolName = "중학교";
                        break;
                }

                let schoolGradeName = "";
                switch(schoolGrade) {
                    case "01":
                        schoolGradeName = "1학년";
                        break;
                    case "02":
                        schoolGradeName = "2학년";
                        break;
                    case "03":
                        schoolGradeName = "3학년";
                        break;
                    case "04":
                        schoolGradeName = "4학년";
                        break;
                    case "05":
                        schoolGradeName = "5학년";
                        break;
                    case "06":
                        schoolGradeName = "6학년";
                        break;
                }

                this.schoolDivGradeName = schoolName + " " + schoolGradeName;
                this.isDisplayPopup = false;

                window.location.reload();
            },
        },
        computed: {
        }
    }
</script>

<style scoped lang="scss">
    div.preview-subject-lecture {
        overflow-y: auto;
        min-height: 100vh;
        padding-bottom: 110px;
    }
</style>
